export default {
  // 全局 dialog Index
  globalDialogIndex: 1000,
};
